(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-fade"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-fade')) {
    class HeroFade extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
        this.index = 0;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.slides.length < 2 || reduce) return;

        this.interval = Math.max(2, Number(this.dataset.interval) || 6) * 1000;
        this.fade = (Number(this.dataset.fade) || 1.2) * 1000;
        this.onVisibility = () => (document.hidden ? this.stop() : this.start());
        document.addEventListener('visibilitychange', this.onVisibility);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
      }

      start() {
        this.stop();
        this.timer = setInterval(() => this.next(), this.interval);
      }

      stop() {
        clearInterval(this.timer);
      }

      next() {
        const previous = this.slides[this.index];
        this.index = (this.index + 1) % this.slides.length;
        const current = this.slides[this.index];

        previous.classList.remove('is-active');
        previous.classList.add('is-prev');
        current.classList.add('is-active');

        clearTimeout(this.cleanup);
        this.cleanup = setTimeout(() => previous.classList.remove('is-prev'), this.fade + 100);
      }
    }
    customElements.define('hero-fade', HeroFade);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
